export default __webpack_public_path__ + "static/media/Level5.318b70d0.svg";